var map = {
	"./cc2.svg": "7314",
	"./document.svg": "3a30",
	"./download-app-store.svg": "5ef3",
	"./download-google-play.svg": "e4f2",
	"./ethereum.svg": "d9aa",
	"./fonts/icomoon.svg": "5173",
	"./icon-american-football.svg": "0be1",
	"./icon-football.svg": "1fa2",
	"./icon-global-tournament.svg": "b9d3",
	"./images/wallet/account_restriction.svg": "6977",
	"./images/wallet/arrow.svg": "a1c5",
	"./images/wallet/checkin.svg": "bbb2",
	"./images/wallet/chz-logo.svg": "2028",
	"./images/wallet/fto.svg": "2434",
	"./images/wallet/history.svg": "a732",
	"./images/wallet/icon-user.svg": "526f",
	"./images/wallet/lock.svg": "ac87",
	"./images/wallet/market.svg": "6969",
	"./images/wallet/marketplace.svg": "d9d8",
	"./images/wallet/prediction.svg": "fd7ed",
	"./images/wallet/receive.svg": "30f0",
	"./images/wallet/survey.svg": "3896",
	"./images/wallet/top-up.svg": "1c0c",
	"./images/wallet/trading-history.svg": "3e07",
	"./images/wallet/voucher.svg": "dc65",
	"./images/wallet/withdraw.svg": "fa96",
	"./muted.svg": "ca80d",
	"./polygon.svg": "c8b2",
	"./stopper-watch.svg": "7bcd",
	"./unmuted.svg": "275a",
	"./vote-loader-dark.svg": "ff47",
	"./vote-loader.svg": "9d00"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";